import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { CountryBreakdownItem } from '../../types';
import { formatNumber, getCountryFlag, getCountryName } from '../../constants/nginx-sites';

interface CountryBreakdownProps {
  data: CountryBreakdownItem[];
}

export function CountryBreakdown({ data }: CountryBreakdownProps) {
  if (!data || data.length === 0) return null;

  const maxCount = Math.max(...data.map((d) => d.count));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Países</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>País</TableHead>
              <TableHead className="text-right">Visitantes</TableHead>
              <TableHead className="text-right">Requisições</TableHead>
              <TableHead className="w-[120px]"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.slice(0, 20).map((item) => (
              <TableRow key={item.country}>
                <TableCell>
                  <span className="mr-2">{getCountryFlag(item.country)}</span>
                  {getCountryName(item.country)}
                </TableCell>
                <TableCell className="text-right">{formatNumber(item.visitors)}</TableCell>
                <TableCell className="text-right">{formatNumber(item.count)}</TableCell>
                <TableCell>
                  <div className="w-full bg-muted rounded-full h-2">
                    <div
                      className="h-2 rounded-full bg-primary"
                      style={{ width: `${(item.count / maxCount) * 100}%` }}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
